/* unplugin-vue-components disabled */import script from "./indexgd.vue?vue&type=script&setup=true&lang=js"
export * from "./indexgd.vue?vue&type=script&setup=true&lang=js"

import "./indexgd.vue?vue&type=style&index=0&id=435628f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-435628f9"]])

export default __exports__